import React from 'react';
import { Calendar, Medal } from 'lucide-react';
export function EliteFeatures() {
  return <section className="py-20 bg-brand-goldLight" data-id="element-65">
      <div className="max-w-5xl mx-auto px-4" data-id="element-66">
        <div className="text-center mb-12" data-id="element-67">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4" data-id="element-68">
            ¿Qué agrega el Megapack Élite?
          </h2>
          <p className="text-xl text-gray-700" data-id="element-69">
            Por solo $9.000 más, llevás tu enseñanza al siguiente nivel.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-70">
          <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-brand-gold relative overflow-hidden" data-id="element-71">
            <div className="absolute top-0 right-0 w-24 h-24 bg-brand-gold/10 rounded-bl-full -mr-4 -mt-4" data-id="element-72"></div>
            <div className="flex items-center gap-4 mb-6" data-id="element-73">
              <div className="bg-brand-gold p-4 rounded-xl text-white" data-id="element-74">
                <Calendar className="w-8 h-8" data-id="element-75" />
              </div>
              <div data-id="element-76">
                <div className="text-brand-gold font-bold text-sm tracking-widest mb-1" data-id="element-77">
                  ÉLITE 1
                </div>
                <h3 className="font-heading font-bold text-xl text-gray-900" data-id="element-78">
                  Planificador Anual Día por Día
                </h3>
              </div>
            </div>
            <p className="text-gray-700 leading-relaxed" data-id="element-79">
              De Enero a Diciembre, todas tus sesiones organizadas. Sabé
              exactamente qué dar el 15 de abril o el 10 de octubre sin tener
              que pensar. La libertad mental total del profe organizado.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-brand-gold relative overflow-hidden" data-id="element-80">
            <div className="absolute top-0 right-0 w-24 h-24 bg-brand-gold/10 rounded-bl-full -mr-4 -mt-4" data-id="element-81"></div>
            <div className="flex items-center gap-4 mb-6" data-id="element-82">
              <div className="bg-brand-gold p-4 rounded-xl text-white" data-id="element-83">
                <Medal className="w-8 h-8" data-id="element-84" />
              </div>
              <div data-id="element-85">
                <div className="text-brand-gold font-bold text-sm tracking-widest mb-1" data-id="element-86">
                  ÉLITE 2
                </div>
                <h3 className="font-heading font-bold text-xl text-gray-900" data-id="element-87">
                  Entrenamiento para Competencia
                </h3>
              </div>
            </div>
            <p className="text-gray-700 leading-relaxed" data-id="element-88">
              El manual para detectar talentos, armar tu equipo y llevar
              nadadores al podio. Pasá de ser el profe que cuida gente en el
              agua al entrenador que forma campeones.
            </p>
          </div>
        </div>
      </div>
    </section>;
}